module.exports = __webpack_public_path__ + "img/truck.95bc82eb.svg";